import type { IconName } from "../../icon-name";
import type { TranslatableType } from "../../translations/translation";
import type { AgendaColumnType } from "./agenda-column-type";
import { agendaColumnZodEnum } from "./agenda-column-type";
import type { AgendaColumnSettings } from "./agenda-column.settings";

const agendaColumn: Record<AgendaColumnType, AgendaColumnType> = {
    upcoming: "upcoming",
    active: "active",
    unhandled: "unhandled",
    fulfilled: "fulfilled",
};
const agendaColumnMeta: Record<
    AgendaColumnType,
    {
        label: {
            today: TranslatableType;
            past: TranslatableType;
            future: TranslatableType;
        };
        description: {
            today: TranslatableType;
            past: TranslatableType;
            future: TranslatableType;
        };
        iconName?: IconName;
        defaultSettings: AgendaColumnSettings;
    }
> = {
    upcoming: {
        label: {
            past: {
                sv: "Incheckad",
                en: "Checked in",
            },
            today: {
                sv: "Incheckningar",
                en: "Check-ins",
            },
            future: {
                sv: "Incheckningar",
                en: "Check-ins",
            },
        },
        description: {
            past: {
                sv: "Bokningar som checkades in under dagen",
                en: "Bookings that were checked in during the day",
            },
            today: {
                sv: "Bokningar som väntar på incheckning idag",
                en: "Bookings waiting for check-in today",
            },
            future: {
                sv: "Bokningar som ska checkas in under dagen",
                en: "Bookings that will be checked in during the day",
            },
        },
        iconName: "fa-clock",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
    active: {
        label: {
            past: {
                sv: "Var aktiva",
                en: "Was active",
            },
            today: {
                sv: "Aktiva",
                en: "Active",
            },
            future: {
                sv: "Aktiva",
                en: "Active",
            },
        },
        description: {
            past: {
                sv: "Bokningar som var aktiva under dagen",
                en: "Bookings that were active during the day",
            },
            today: {
                sv: "Bokningar som är aktiva idag varav en del kanske ska checkas ut.",
                en: "Bookings that are active today, some of which may need to be checked out.",
            },
            future: {
                sv: "Bokningar kommer att vara aktiva under dagen.",
                en: "Bookings that will be active during the day.",
            },
        },
        iconName: "fa-running",
        defaultSettings: {
            showBlocked: true,
            showDropIns: true,
            showExtras: true,
        },
    },
    fulfilled: {
        label: {
            past: {
                sv: "Utcheckade",
                en: "Checked out",
            },
            today: {
                sv: "Utcheckade",
                en: "Checked out",
            },
            future: {
                sv: "Checkar ut",
                en: "Checking out",
            },
        },
        description: {
            past: {
                sv: "Bokningar checkades ut under dagen",
                en: "Bookings that were checked out during the day",
            },
            today: {
                sv: "Bokningar som checkats ut idag",
                en: "Bookings that were checked out today",
            },
            future: {
                sv: "Bokningar som kommer att checkas ut under dagen.",
                en: "Bookings that will check out during the day.",
            },
        },
        iconName: "fa-check",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
    unhandled: {
        label: {
            past: null,
            today: {
                sv: "Ej hanterade",
                en: "Unhandled",
            },
            future: null,
        },
        description: {
            past: null,
            today: {
                sv: "Bokningar som borde vara aktiva och skulle checkats in tidigare dag, men som ännu inte checkats in",
                en: "Bookings that should be active and were supposed to be checked in before today, but have not been checked in yet",
            },
            future: null,
        },
        iconName: "fa-exclamation-triangle",
        defaultSettings: {
            showBlocked: false,
            showDropIns: false,
            showExtras: true,
        },
    },
};

export { agendaColumn, agendaColumnMeta, agendaColumnZodEnum };
export type { AgendaColumnType };
